import {
  getGridStringOperators,
  GridColDef,
  GridFilterItem,
} from '@rossum/ui/x-data-grid-pro';
import { isNonEmptyObject } from '../field-detail/getProcessRowUpdate';

export const arrayObjectOperators = getGridStringOperators().map(operator => ({
  ...operator,
  getApplyFilterFn: (filterItem: GridFilterItem, column: GridColDef) => {
    const filterFunction =
      operator.getApplyFilterFn?.(filterItem, column) ?? null;

    return filterFunction === null
      ? null
      : (v: { [key: string]: number }): boolean => {
          const value = isNonEmptyObject(v)
            ? Object.keys(v || {})
                .map(label => label)
                .join(' ')
            : null;

          // @ts-expect-error default string oerators expect only first argument
          return filterFunction(value);
        };
  },
}));
